import { supabase, getUid } from "./supabase";
import { enqueue } from "./outbox";
import { cacheGet, cacheSet } from "./dataCache";

/* Drill stats persistence (Pro). Writes go through drill_record (is_pro-gated);
   reads through drill_summary (own-row). Both are best-effort from the UI —
   a failure just means a card or two isn't tallied, never a broken drill. */

/* DELIBERATE: daily rollups key on the DEVICE-LOCAL date (a "day of
   practice" as the player experiences it), while seasons/leaderboards are
   UTC (see leaderboard.js seasonOf). A traveler can therefore write into a
   different day than admin/UTC aggregates show — accepted; do not "fix" one
   side without the other. speedStats.js mirrors this. */
const localDay = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export async function recordDrillRaw(deltas, day) {
  const { error } = await supabase.rpc("drill_record", { p_deltas: deltas, p_day: day });
  if (error) {
    console.warn("drill_record failed:", error.message);
    return false;
  }
  return true;
}

export async function recordDrill(deltas) {
  if (!deltas || deltas.length === 0) return { ok: false };
  const day = localDay();
  const ok = await recordDrillRaw(deltas, day);
  // Additive deltas → queue per call (not coalesced) so the offline day's tally
  // replays exactly once on reconnect.
  if (!ok) enqueue({ kind: "drill", payload: { deltas, day } });
  return { ok };
}

export async function getDrillSummary(system, h17) {
  const uid = await getUid();
  const key = uid ? `drillSummary:${uid}:${system}:${!!h17}` : null;
  const { data, error } = await supabase.rpc("drill_summary", {
    p_system: system,
    p_h17: !!h17,
  });
  if (error) {
    console.warn("drill_summary failed:", error.message);
    return cacheGet(key) ?? null;
  }
  cacheSet(key, data);
  return data;
}

/* Per-(system, day) drill rollup for the Progress page's mastery-over-time line.
   Own-rows via RLS; oldest day first so the client can bucket into a series. */
export async function getDrillDaily(system) {
  const uid = await getUid();
  if (!uid) return [];
  let q = supabase
    .from("drill_daily")
    .select("system, day, attempts, correct")
    .eq("user_id", uid);
  if (system && system !== "All") q = q.eq("system", system);
  const key = `drillDaily:${uid}:${system ?? "All"}`;
  const { data, error } = await q.order("day", { ascending: true });
  if (error) {
    console.warn("drill_daily fetch failed:", error.message);
    return cacheGet(key) ?? [];
  }
  cacheSet(key, data ?? []);
  return data ?? [];
}
